import baseInfo from './base'
import locationInfo from './location'
import specialConfig from './specialYear'
import _ from 'lodash'

export { locationInfo }

export default function (year, location) {
  let applyInfo = JSON.parse(JSON.stringify(baseInfo))

  if (specialConfig[location] && specialConfig[location][year]) {
    _.merge(applyInfo, locationInfo[location], specialConfig[location][year])
  } else if (locationInfo[location]) {
    _.merge(applyInfo, locationInfo[location])
  }

  return applyInfo
}
